import React from 'react'
import PropTypes from 'prop-types'

import VocabularyWord from 'src/ui/VocabularyWord/VocabularyWord'

import VocabularyWordListSkeleton from './VocabularyWordListSkeleton'

const VocabularyWordList = ({ items }) => {
  return (
    <VocabularyWordListSkeleton items={items} ItemComponent={VocabularyWord} />
  )
}

VocabularyWordList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
}

export default VocabularyWordList
